export const ExpectedUnhandledPromiseErrors = [
  'chrome-extension://',
  'getPrimitives (https://r.bing.com', // External Bing Maps JS error. Maximum call stack size exceeded; StackTrace: n.getPrimitives (https://r.bing.com/rp/aM22Q_c9IMk-AUe7HQJtiK1nLXk.br.js:1:113176)
  'Message: Failed to fetch',
  '{"readyState":0,"status":0,"statusText":"error","headers":{}}',
  'Load failed at undefined',
].map(error => error.toLowerCase());
